import addDatePickers from './add-date-pickers';
import $ from 'jquery';
import './vendor/facebox';

/**
 * Looks for elements with a data-facebox-selector attribute.
 * When clicked, the value of the data attribute is used as a CSS
 * selector for finding another element whose content is rendered
 * into a modal.
 */
$(document).on('click', '[data-facebox-selector]', function (e) {
  e.preventDefault();
  const html = $($(this).attr('data-facebox-selector')).html();
  $.facebox(html);
  addDatePickers();
});

/**
 * Looks for elements with a data-close-faceboox attribute.
 * On click, closes the currently open modal.
 */
$(document).on('click', '[data-close-facebox]', function (e) {
  e.preventDefault();
  $(document).trigger('close.facebox');
});
